(function ($) {
    "use strict";

	var $window = $(window);
	var $body = $('body');

	/* Preloader Effect */
	$window.on('load', function(){
		$(".preloader").fadeOut(600);
	});

	/* Sticky Header */
	if($('.active-sticky-header').length){
		$window.on('resize', function(){
			setHeaderHeight();
		});

		function setHeaderHeight(){
	 		$("header.main-header").css("height", $('header .header-sticky').outerHeight());
		}

		$window.on("scroll", function() {
			var fromTop = $(window).scrollTop();
			setHeaderHeight();
			var headerHeight = $('header .header-sticky').outerHeight()
			$("header .header-sticky").toggleClass("hide", (fromTop > headerHeight + 100));
			$("header .header-sticky").toggleClass("active", (fromTop > 600));
		});
	}

	/* Slick Menu JS */
	$('#menu').slicknav({
		label : '',
		prependTo : '.responsive-menu'
	});

	if($("a[href='#top']").length){
		$(document).on("click", "a[href='#top']", function() {
			$("html, body").animate({ scrollTop: 0 }, "slow");
			return false;
		});
	}

	/* Hero Slider Layout JS */
	// const hero_slider_layout = new Swiper('.hero-slider-layout .swiper', {
	// 	effect: 'fade',
	// 	slidesPerView : 1,
	// 	speed: 1000,
	// 	spaceBetween: 0,
	// 	loop: true,
	// 	autoplay: {
	// 		delay: 4000,
	// 	},
	// 	pagination: {
	// 		el: '.hero-pagination',
	// 		clickable: true,
	// 	},
	// });

	/* Product Slider Slider JS */
	// if ($('.product-slider').length) {
	// 	const testimonial_company_slider = new Swiper('.product-slider .swiper', {
	// 		slidesPerView : 1,
	// 		speed: 2000,
	// 		spaceBetween: 30,
	// 		loop: true,
	// 		autoplay: {
	// 			delay: 5000,
	// 		},
	// 		navigation: {
	// 			nextEl: '.product-button-next',
	// 			prevEl: '.product-button-prev',
	// 		},
	// 		breakpoints: {
	// 			768:{
	// 			  	slidesPerView: 2,
	// 			},
	// 			991:{
	// 			  	slidesPerView: 4,
	// 			}
	// 		}
	// 	});
	// }

	// /* testimonial Slider JS */
	// if ($('.testimonial-slider').length) {
	// 	const testimonial_slider = new Swiper('.testimonial-slider .swiper', {
	// 		slidesPerView : 1,
	// 		speed: 1000,
	// 		spaceBetween: 30,
	// 		centeredSlides: true,
	// 		loop: true,
	// 		autoplay: {
	// 			delay: 5000,
	// 		},
	// 		pagination: {
	// 			el: '.testimonial-pagination',
	// 			clickable: true,
	// 		},
	// 		navigation: {
	// 			nextEl: '.testimonial-button-next',
	// 			prevEl: '.testimonial-button-prev',
	// 		},
	// 		breakpoints: {
	// 			768:{
	// 				slidesPerView: 2,
	// 			},
	// 			991:{
	// 				slidesPerView: 3,
	// 			}
	// 		}
	// 	});
	// }

	/* Youtube Background Video JS - Removed - Not used */
	// if ($('#herovideo').length) {
	//	var myPlayer = $("#herovideo").YTPlayer();
	// }

	/* Init Counter */
	if ($('.counter').length) {
		$('.counter').counterUp({ delay: 6, time: 3000 });
	}

	/* Image Reveal Animation */
	if ($('.reveal').length) {
        gsap.registerPlugin(ScrollTrigger);
        let revealContainers = document.querySelectorAll(".reveal");
        revealContainers.forEach((container) => {
            let image = container.querySelector("img");
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    toggleActions: "play none none none"
                }
            });
            tl.set(container, {
                autoAlpha: 1
            });
            tl.from(container, 1, {
                xPercent: -100,
                ease: Power2.out
            });
            tl.from(image, 1, {
                xPercent: 100,
                scale: 1,
                delay: -1,
                ease: Power2.out
            });
        });
    }

	/* Text Effect Animation */
	if ($('.text-anime-style-1').length) {
		let staggerAmount 	= 0.05,
			translateXValue = 0,
			delayValue 		= 0.5,
		   animatedTextElements = document.querySelectorAll('.text-anime-style-1');

		animatedTextElements.forEach((element) => {
			let animationSplitText = new SplitText(element, { type: "chars, words" });
				gsap.from(animationSplitText.words, {
				duration: 1,
				delay: delayValue,
				x: 20,
				autoAlpha: 0,
				stagger: staggerAmount,
				scrollTrigger: { trigger: element, start: "top 85%" },
				});
		});
	}

	if ($('.text-anime-style-2').length) {
		let	 staggerAmount 		= 0.03,
			 translateXValue	= 20,
			 delayValue 		= 0.1,
			 easeType 			= "power2.out",
			 animatedTextElements = document.querySelectorAll('.text-anime-style-2');

		animatedTextElements.forEach((element) => {
			let animationSplitText = new SplitText(element, { type: "chars, words" });
				gsap.from(animationSplitText.chars, {
					duration: 1,
					delay: delayValue,
					x: translateXValue,
					autoAlpha: 0,
					stagger: staggerAmount,
					ease: easeType,
					scrollTrigger: { trigger: element, start: "top 85%"},
				});
		});
	}

	/* Parallaxie js */
	var $parallaxie = $('.parallaxie');
	if($parallaxie.length && ($window.width() > 991))
	{
		if ($window.width() > 768) {
			$parallaxie.parallaxie({
				speed: 0.55,
				offset: 0,
			});
		}
	}

	/* Contact form validation */
	var $contactform = $("#contactForm");
	$contactform.validator({focus: false}).on("submit", function (event) {
		if (!event.isDefaultPrevented()) {
			event.preventDefault();
			submitForm();
		}
	});

	function submitForm(){
		/* Ajax call to submit form */
		$.ajax({
			type: "POST",
			url: "form-process.php",
			data: $contactform.serialize(),
			success : function(text){
				if (text === "success"){
					formSuccess();
				} else {
					submitMSG(false,text);
				}
			}
		});
	}

	function formSuccess(){
		$contactform[0].reset();
		submitMSG(true, "Message Sent Successfully!")
	}

	function submitMSG(valid, msg){
		if(valid){
			var msgClasses = "h4 text-success";
		} else {
			var msgClasses = "h4 text-danger";
		}
		$("#msgSubmit").removeClass().addClass(msgClasses).text(msg);
	}
	/* Contact form validation end */

	/* Animated Wow Js */
	// new WOW().init();

	/* Popup Video */
	if ($('.popup-video').length) {
		$('.popup-video').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: true
		});
	}

	/* Approach Item Active Start */
	var $approach_list = $('.approach-list');
	if ($approach_list.length) {
		var $service_item = $approach_list.find('.approach-item');

		if ($service_item.length) {
			$service_item.on({
				mouseenter: function () {
					if (!$(this).hasClass('active')) {
						$service_item.removeClass('active');
						$(this).addClass('active');
					}
				},
				mouseleave: function () {
					// Optional: Add logic for mouse leave if needed
				}
			});
		}
	}
	/* Approach Item Active End */

	/* Features List Active Start */
	var $features_list = $('.features-list');
	if ($features_list.length) {
		var $features_item = $features_list.find('.features-item');

		if ($features_item.length) {
			$features_item.on({
				mouseenter: function () {
					if (!$(this).hasClass('active')) {
						$features_item.removeClass('active');
						$(this).addClass('active');
					}
				},
				mouseleave: function () {
					// Optional: Add logic for mouse leave if needed
				}
			});
		}
	}
	/* Features List Active End */

})(jQuery);
